<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import formProdutor from '@/src/components/form-produtor'
import importProdutor from '@/src/components/import-produtor.vue'

import produtor from '@/src/services/produtor-rural'

import { mask } from 'vue-the-mask'

/**
 * Produtor rural Component
 */
export default {
  directives: { mask },
  components: {
    Layout,
    Loading,
    formProdutor,
    importProdutor,
  },
  data() {
    return {
      produtorRural: {},
      produtores: [],
      mostraForm: true,
      idUser: null,
      filter: '',
      produtorFields: [        
        {
          key: 'nome',
          label: 'Nome',
        },
        {
          key: 'endereco',
          label: 'Endereço'
        },
        { key: 'actions', label: '' },
      ],
      currentPage: 1,
      perPage: 20,
      rows: 0,
      showModal: false,
      modalImport: false,
      isLoading: false,
    }
  },
  computed: {},
  watch: {
    currentPage() {
      this.handleRefreshList()
    },
  },
  mounted() {
    this.listando()
  },
  methods: {
    loading(a) {
      a = !this.isLoading
      return a
    },
    getPaginatedPayload(resposta) {
      const payload = resposta && resposta.data ? resposta.data : {}
      const pagination = payload.pagination || {}
      const items = Array.isArray(payload.data)
        ? payload.data
        : Array.isArray(payload.dados)
          ? payload.dados
          : Array.isArray(payload.items)
            ? payload.items
            : []

      const total = Number(
        pagination.total ||
        payload.total ||
        payload.totalItems ||
        payload.total_count ||
        payload.count ||
        (resposta && resposta.headers ? resposta.headers['x-total-count'] : 0) ||
        items.length
      )

      return {
        items,
        total,
        page: Number(pagination.page || this.currentPage),
        limit: Number(pagination.limit || this.perPage),
        totalPages: Number(
          pagination.totalPages ||
          (total && (pagination.limit || this.perPage)
            ? Math.ceil(total / Number(pagination.limit || this.perPage))
            : 0)
        ),
      }
    },
    handleRefreshList() {
      if (this.filter && String(this.filter).trim() !== '') {
        this.listandoByFilter()
        return
      }

      this.listando()
    },
    listando() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.show)
      produtor
        .listar(token, this.currentPage, this.perPage)
        .then((resposta) => {
          const { items, total, page, limit } = this.getPaginatedPayload(resposta)
          this.produtores = items
          this.rows = total
          this.currentPage = page
          this.perPage = limit
          this.isLoading = this.loading(this.show)
        })
        .catch((error) => {
          this.isLoading = false
        })
    },
    listandoByFilter() {
      if (this.filter != undefined && String(this.filter).trim() !== '') {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = true
        produtor
          .listarByFilter(token, this.filter, this.currentPage, this.perPage)
          .then((resposta) => {
            const { items, total, page, limit } = this.getPaginatedPayload(resposta)
            this.produtores = items
            this.rows = total
            this.currentPage = page
            this.perPage = limit
            this.isLoading = false
          })
          .catch((error) => {
            this.produtores = []
            this.rows = 0
            this.isLoading = false
          })
      } else {
        this.listando()
      }
    },
    cadastro() {
      if (this.produtorRural) {
        this.produtorRural = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listando()
      }
    },
    modalDelete(id) {
      this.showModal = true
      this.idUser = id
    },
    handleDelete() {
      const token = this.$store.state.auth.currentUser.token
      produtor
        .deletar(token, this.idUser)
        .then((resposta) => {
          this.listando()
        })
        .catch((err) => {
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idUser = null
      this.showModal = false
    },
    showForm(produtor) {
      this.produtorRural = produtor
      this.mostraForm = false
    },
    abrirForm() {
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.produtorRural = {}
        this.listando()
      }
    },
    handlePesquisar() {
      this.currentPage = 1
      this.handleRefreshList()
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Produtores</div>
            <div class="subTitulo"
              >Visualize, edite e cadastre novos produtores na plataforma.</div
            >
          </div>
          <div class="col-md-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="abrirForm">
                <span v-if="mostraForm">Novo</span>
                <span v-else>Ver todos</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div v-if="mostraForm" class="row">
          <div class="col-md-4 col-sm-4 col-xs-4">
            <b-form-group id="input-group-1" label="Nome" label-for="filter">
              <b-form-input
                id="filter"
                v-model="filter"
                type="text"
                @keyup.enter="handlePesquisar"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-4 col-sm-4 col-xs-4 mt-4 pt-1">
            <button class="btn btn-primary" @click="handlePesquisar"
              >Pesquisar</button
            >
          </div>
          <div class="col-md-4 col-sm-4 col-xs-4 mt-4 pt-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="modalImport = true"
                >Importar</button
              >
            </div>
          </div>
        </div>
      </div>
      <div>
        <div v-if="mostraForm">
          <div class="total-registros">
            Total de registros: <strong>{{ rows }}</strong>
          </div>
          <b-table
            striped
            hover            
            responsive="sm"
            borderless
            bordered
            outlined
            small
            :items="produtores"
            :fields="produtorFields"
          >
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <b-dropdown
                    size="md"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    v-b-tooltip.hover
                    title="Edite ou Delete um Produtor"
                  >
                    <template #button-content>
                      <i class="uil uil-ellipsis-v"></i>
                    </template>
                    <b-dropdown-item @click="showForm(row.item)"
                      >Editar</b-dropdown-item
                    >
                    <b-dropdown-item @click="modalDelete(row.item.id_produtor_rural)"
                      >Excluir</b-dropdown-item
                    >
                  </b-dropdown>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            size="md"
            :total-rows="rows"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div v-else>
          <formProdutor :produtor="produtorRural" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal v-model="showModal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="showModal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <b-modal
      size="lg"
      v-model="modalImport"
      title="Importação de Produtores"
      title-class="font-18"
      @hide="listando"
    >
      <importProdutor></importProdutor>
      <template v-slot:modal-footer>
        <b-button variant="primary" @click="modalImport = false"
          >Sair</b-button
        >
      </template>
    </b-modal>

    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  border: solid 1px rgba(0, 0, 0, 0.125);
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px rgba(0, 0, 0, 0.125);
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .total-registros {
    margin-top: 8px;
    margin-bottom: 12px;
    color: #4b5563;
    font-size: 14px;
    text-align: right;
  }
}
</style>
